import { EventEmitter } from '@angular/core';
import { GenericListLinkClickHandlerData } from './generic-list-link-click-handler-data';

export class GenericListLinkDefinition {
  linkColor: string;
  linkTitle: string;
  data: any;
  clickHandler: EventEmitter<GenericListLinkClickHandlerData>;
  disabled = false;

  constructor(
    data: any,
    clickHandler: EventEmitter<GenericListLinkClickHandlerData>,
    linkTitle: string,
    linkColor = 'primary',
    disabled?: boolean
  ) {
    this.linkColor = linkColor;
    this.linkTitle = linkTitle;
    this.data = data;
    this.clickHandler = clickHandler;
    this.disabled = disabled;
  }
}
